module.exports = __webpack_public_path__ + "img/banner-1-m.c5fc3af3.jpg";